import {IController, IPromise, IQService, IScope} from "angular";
import {Page, Pageable} from "../../utils/models/Page";
import {DirectMailerLogFilterUi} from "../../opportunities_filter/model/OpportunityFilterUi";
import {DirectMailerLogsServiceName} from "../../utils/names/serviceNames";
import {DirectMailerLogsService} from "../service/DirectMailerLogsService";
import {DirectMailerLogDTO} from "../model/DirectMailerLogDTO";
import {Calculator} from "../../calculations/model/Calculator";


interface DirectMailerLogsControllerScope extends IScope {
    fetchDirectMailerLogs: () => IPromise<Page<DirectMailerLogDTO>>;
    onFilterValueChange: (filterVal: DirectMailerLogFilterUi) => void;
    logs: DirectMailerLogDTO[];
    pagingConfig: Pageable;
    cancelCall: () => void;
}

export class LoggingController implements IController {

    static instance = ['$scope', '$q', DirectMailerLogsServiceName, LoggingController];

    loggingService: DirectMailerLogsService;

    $scope: DirectMailerLogsControllerScope;

    filterVal: DirectMailerLogFilterUi;

    $q: IQService;

    constructor($scope: DirectMailerLogsControllerScope,
                $q: IQService,
                loggingService: DirectMailerLogsService) {
        this.loggingService = loggingService;
        this.$scope = $scope;
        this.$q = $q;
        $scope.pagingConfig = {page: 1, pageSize: 10, totalElements: 0,  fetchPage: this.refreshLogs};
        $scope.fetchDirectMailerLogs = this.fetchDirectMailerLogs;
        $scope.onFilterValueChange = this.onFilterValueChange;
    }

    $onInit() {
        this.fetchDirectMailerLogs();
    }

    refreshLogs = () => this.onFilterValueChange(this.filterVal);

    onFilterValueChange = (filterVal: DirectMailerLogFilterUi) => {
        if (!filterVal.isSuccess) {
            //means that filter should not be applied when isSuccess is false rather then
            delete filterVal['isSuccess'];
        }
        this.filterVal = filterVal;
        this.fetchDirectMailerLogs();
    };

    fetchDirectMailerLogs = () => {
        let canceler = this.$q.defer();
        let $scope = this.$scope;
        if ($scope.cancelCall !== undefined) {
            $scope.cancelCall();
        }
        let page = $scope.pagingConfig.page;
        let pageSize = $scope.pagingConfig.pageSize;
        let promise = this.loggingService.getAllDirectMailerLogs((page - 1), pageSize, this.filterVal, canceler)
            .then(resp => {

                let logsPage = resp.data;
                if (logsPage === null) {
                    return null;
                }
                logsPage.content.forEach(log => {
                    log.imageUrl = Calculator.getImageUrl(log.calculatorName);
                });
                let pageConfig = $scope.pagingConfig;
                pageConfig.totalElements = logsPage.totalElements;
                pageConfig.page = (logsPage.number + 1);
                pageConfig.pageSize = logsPage.size;
                $scope.logs = logsPage.content;
                return logsPage;
            });
        $scope.cancelCall = function(){
            canceler.resolve();
        }
        return promise;
    };
}